import CheckIcon from '@mui/icons-material/Check';
import { InlineWidget } from "react-calendly";
import { Button, useMediaQuery, useTheme } from "@mui/material";

const Calendly = ({handleClick}) => {
    const theme = useTheme();
    const isBig = useMediaQuery(theme.breakpoints.down(1250));
    const isMobile = useMediaQuery(theme.breakpoints.down(890));
    const isSmall = useMediaQuery(theme.breakpoints.down(450));

    const styles = {
        container: {
            background: 'black',
            color: 'white',
            paddingTop: '50px'
        },
        mainBox: {
            display: 'flex',
            justifyContent: 'center',
        },
        subContainer: {
            width: isSmall ? '100%' : '80%',
            marginTop: 50,
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            gap: '20px',
            justifyContent: 'center',
            alignItems: isMobile ? 'center' : '',
        },
        greenIconBox: {
            borderRadius: '50%',
            backgroundColor: 'green',
            width: '25px',
            height: '25px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        iconText: {
            width: '95%',
            lineHeight: 1.2
        },
        icon: {
            fontSize: 15,
            fontWeight: 'bold',
            color: 'white'
        },
        buttonContainer: {
            marginTop: 20,
            textAlign: 'center',
        },
        button: {
            borderRadius: '30px',
            color: 'black',
            backgroundColor: 'rgb(255, 210, 48)',
            padding: '15px 60px',
            textTransform: 'none',
            fontWeight: 'bold',
            fontSize: '20px',
            '&:hover': {
                backgroundColor: 'rgb(255, 210, 48)',
                color: '#fff'
            },
            marginTop: 5,
            fontWeight: 'bold'
        },
    }

    return (
        <div style={styles.container}>
            <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', marginTop: isSmall ? 5 : 10 }}>
                <div style={{ width: isMobile ? '100%' : isBig ? '85%' : '70%', textAlign: 'center', fontSize: isSmall ? '30px' : isMobile ? '38px' : '45px', fontWeight: 'bold' }} >
                    Book In Your Free '1-on-1 Discovery Call' Below
                </div>
                {/* <div style={{ width: isMobile ? '85%' : isBig ? '75%' : '60%', textAlign: 'center', margin: '20px 0', fontWeight: 'bold' }}>
                    Once your booked in, we'll be able to send you downloadable assets, resources and training prior to our call!
                </div> */}
            </div>

            <div style={styles.mainBox}>
                <div style={styles.subContainer}>
                    <div style={{ width: isMobile ? '95%' : '50%', lineHeight: 2 }}>
                        <div style={{ fontSize: isMobile ? '20px' : '24px', fontWeight: 'bold', color: 'white' }}>Who Is This For?</div>

                        <div style={{ padding: isMobile ? '10px' : '20px' }}>
                            <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginBottom: 20 }}>
                                <div style={styles.greenIconBox}>
                                    <CheckIcon sx={styles.icon} />
                                </div>

                                <div style={styles.iconText}>
                                    Businesses that never want to worry about next month's sales again
                                </div>
                            </div>

                            <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginTop: 10, marginBottom: 20 }}>
                                <div style={styles.greenIconBox}>
                                    <CheckIcon sx={styles.icon} />
                                </div>

                                <div style={styles.iconText}>
                                    Businesses that want to fiercely increase their MoM growth rate
                                </div>
                            </div>

                            <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginTop: 10, marginBottom: 20 }}>
                                <div style={styles.greenIconBox}>
                                    <CheckIcon sx={styles.icon} />
                                </div>

                                <div style={styles.iconText}>
                                    Businesses that are looking for a reliable agency that can make their company a priority.
                                </div>
                            </div>


                            <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginTop: 10, marginBottom: 20 }}>
                                <div style={styles.greenIconBox}>
                                    <CheckIcon sx={styles.icon} />
                                </div>

                                <div style={styles.iconText}>
                                    Businesses that are committed to growth and want to dominate competition
                                </div>
                            </div>

                            <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginTop: 10, marginBottom: 20 }}>
                                <div style={styles.greenIconBox}>
                                    <CheckIcon sx={styles.icon} />
                                </div>

                                <div style={styles.iconText}>
                                    Businesses that have reached the inevitable eCommerce glass ceiling and want to smash through it.
                                </div>
                            </div>

                            <div style={styles.buttonContainer}>
                                <Button sx={styles.button} onClick={handleClick}>Schedule a Call</Button>
                            </div>
                        </div>
                    </div>
                    {/* <div style={{ width: isMobile ? '100%' : '45%' }}>
                        <InlineWidget url="https://calendly.com/your_scheduling_page" />
                    </div> */}
                </div>
            </div>
        </div>
    )
}

export default Calendly;